const styles = (theme) => ({
  detailsRow: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    alignItems: "center",
  },
  root: {
    flexGrow: 1,
  },
  flexRow: {
    display: "flex",
    direction: "column",
    "&>div": {
      flex: 1,
      width: "100%",
    },
  },
  headerLabel: {
    fontSize: theme.dispatchCardTextFontSize,
    color: theme.TextColor,
    opacity: 0.6,
    marginTop: 8,
  },
  fullWidth: { width: "100%" },
  countryDetailWidth: { width: "49%" },
  infoText: {
    fontSize: theme.dispatchCardTextFontSize,
    color: theme.TextColor,
    opacity: 0.6,
  },
  hazmatContainer: {
    float: "right",
    margin: 8,
  },
  hazmatCollapsibleSection: {
    boxShadow: `0px 1px 3px 0px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 2px 1px -1px rgb(0 0 0 / 14%)`,
    marginBottom: 16,
    padding: 16,
    backgroundColor: theme.gridBGColor,
  },
  hazmatCollapsibleSectionError: {
    border: `1px solid ${theme.errorBorderColor}`,
  },
  huInput: {
    width: "38%",
  },
  packageTypeInput: {
    width: "60%",
  },
  packageDetailsSection: {
    marginBottom: 12,
  },
  flexRowWithSpacing: {
    display: "flex",
    justifyContent: "space-between",
  },
  rowLabelColor: {
    color: theme.TextColor,
  },
  actionButton: {
    textTransform: "uppercase",
  },
});

export default styles;
